module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "content resetpwd"
  }, [_c('div', {
    staticClass: "title font-size24 color-msg"
  }, [_vm._v("重置成功")]), _vm._v(" "), _c('div', {
    staticClass: "font-size14 color-msg cue"
  }, [_vm._v("恭喜您，帐号"), _c('span', [_vm._v(_vm._s(_vm.account))]), _vm._v("密码重置成功")]), _vm._v(" "), _c('div', {
    staticClass: "font-size14 color-msg bottom-cue"
  }, [_vm._v(_vm._s(_vm.timer) + "S自动跳转登录，"), _c('span', {
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("立即跳转>")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72a11d27","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/ResetpwdSuccess.vue
// module id = 134
// module chunks = 1